import React, { createContext, useContext, useState, useEffect } from 'react';
import seedData from '../data/seed.json';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Her zaman seed.json'dan veri okunacak ve localStorage kullanılmayacak
    setData(seedData);
    setIsLoading(false);
  }, []);

  // Admin panel fonksiyonları (yalnızca geçici önizleme için)
  const updateSiteSettings = (settings) => {
    const newData = { ...data, siteSettings: { ...data.siteSettings, ...settings } };
    setData(newData);
  };

  const addProject = (project) => {
    const newProject = { ...project, id: Date.now().toString() };
    const newData = { ...data, projects: [...data.projects, newProject] };
    setData(newData);
    return newProject;
  };

  const updateProject = (projectId, updates) => {
    const newProjects = data.projects.map((p) =>
      p.id === projectId ? { ...p, ...updates } : p
    );
    const newData = { ...data, projects: newProjects };
    setData(newData);
  };

  const deleteProject = (projectId) => {
    const newProjects = data.projects.filter((p) => p.id !== projectId);
    const newFeatured = (data.featuredProjectIds || []).filter((id) => id !== projectId);
    const newData = { ...data, projects: newProjects, featuredProjectIds: newFeatured };
    setData(newData);
  };

  const setFeaturedProjects = (projectIds) => {
    const newProjects = data.projects.map((p) => {
      const index = projectIds.indexOf(p.id);
      return {
        ...p,
        featuredOrder: index >= 0 ? index + 1 : null,
      };
    });
    const newData = { ...data, projects: newProjects };
    setData(newData);
  };

  const getProject = (projectId) => {
    return data?.projects?.find((p) => p.id === projectId);
  };

  const getFeaturedProjects = () => {
    if (!data) return [];
    return data.projects
      .filter((p) => p.featuredOrder && p.featuredOrder >= 1 && p.featuredOrder <= 5)
      .sort((a, b) => a.featuredOrder - b.featuredOrder);
  };

  const resetToSeed = () => {
    setData(seedData);
  };

  const value = {
    data,
    isLoading,
    siteSettings: data?.siteSettings,
    projects: data?.projects || [],
    featuredProjectIds: data?.projects?.filter(p => p.featuredOrder)?.sort((a,b) => a.featuredOrder - b.featuredOrder)?.map(p => p.id) || [],
    updateSiteSettings,
    addProject,
    updateProject,
    deleteProject,
    setFeaturedProjects,
    getProject,
    getFeaturedProjects,
    resetToSeed,
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export default DataContext;
